import React, {Component} from 'react';
import {Form, Upload, Icon, Button} from 'antd';
import {uploadPageFile} from '../../../modules/Api';
import {END_POINT} from '../../../constants/config';


const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
};

class FormInputUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            link : props.initialValue ? props.initialValue : ''
        }
    }


    render(){
        const field = this.props.field ? this.props.field : 'image';
        const label = this.props.label ? this.props.label : 'عکس';
        const extra = this.props.extra ? this.props.extra : '';
        const preview_style = this.props.preview_style ? this.props.preview_style : {width: '50px', height: '50px', margin: '10px'};
        const required = this.props.required === undefined ? true : this.props.required;
        return (

            <Form.Item
            {...formItemLayout}
            label={label}
            extra={extra}
            colon={false}>
            {this.props.getFieldDecorator(field, {
                initialValue: this.props.initialValue ? this.props.initialValue : '',
                rules: [
                    { required: required, message: 'این قسمت الزامی است.' },
                ],
            })(
                <Upload
                name={field + "_link"}
                action=""
                customRequest={() => {}}
                onChange={f => {uploadPageFile(f, (src) => {
                    this.props.update(src, field)
                    this.setState({link: src});
                })}}
                listType="picture"
                showUploadList={false}>
                <Button>
                    <Icon type="upload" /> انتخاب فایل
                </Button>
                <br />
                {
                    this.state.link != null
                    &&
                    <img src={`${this.state.link.includes('http') ? this.state.link : END_POINT + this.state.link}`}
                        style={preview_style}
                        alt="عکس"
                    />
                }
                </Upload>
            )}
            </Form.Item>
        );
    }

}


export default FormInputUpload;



// WEBPACK FOOTER //
// ./src/containers/Pages/Partials/FormInputUpload.js